<template>
  <a-form-item
    :label="data.fieldname"
    class="ridio"
  >
    <div class="right">
      <div
        v-if="data.fieldtype === 'radioinfo_type' && infoSignOptions.length && infoSign"
        class="top"
      >
        <a-checkbox
          :checked="isBeian === 1"
          :disabled="!infoSign.isedit && ($route.name === 'InqueryPassDetail' || $route.name === 'InqueryDetail')"
          @change="onChangeBeian"
        >
          {{ infoSignOptions[0].name }}
        </a-checkbox>
        <span class="text fs-gray">
          {{ $t('message[1756]') }}
        </span>
      </div>
      <div
        v-if="data.isedit || $route.name === 'InqueryCreate' || $route.name === 'ClueCreate'"
        class="con"
      >
        <a-radio-group
          v-decorator="[`${data.fieldkey}`, {
            validateTrigger: ['change', 'blur'],
            rules: [{ required: data.isneeded === 1, message: ' ' }, { validator: checkValue }],
            initialValue: fieldvalue
          }]"
          @change="onChangeVal"
        >
          <a-radio-button
            v-for="item in options"
            :key="item.id"
            :value="item.id"
          >
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
        <a-tooltip
          v-if="isexplain || (data.fieldkey === 'info_type' && data.isexplain)"
          placement="right"
          overlay-class-name="radio-tooltip"
        >
          <template slot="title">
            <template v-for="(item, i) in explain">
              <p
                v-if="item.name"
                :key="i"
              >
                {{ item.key }}: {{ item.name }}
              </p>
            </template>
          </template>
          <i
            v-if="(isexplain || data.fieldkey === 'info_type') && explain.length"
            class="iconfont iconicon-test34 fs-gray explain-btn"
          />
        </a-tooltip>
      </div>
      <not-can-edit-item
        v-else
        :data="data"
      />
    </div>
  </a-form-item>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import NotCanEditItem from './NotCanEdit'

export default {
  components: {
    NotCanEditItem
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: 0
    }
  },
  inject: ['myForm'],
  data () {
    return {
      isBeian: 0, // 是否选中备案
      fieldvalue: this.data.fieldvalue
    }
  },

  computed: {
    ...mapState(['baseinfo']),
    ...mapGetters('inquery/detailData', ['memberInfo', 'passdetailMemberInfo']),
    ...mapGetters('inquery/addConfigData', ['defaultMemberInfo']),
    systemRole () {
      const { system_role: systemRole } = this.baseinfo || {}
      return systemRole
    },
    isexplain () {
      const { fieldconfig = {} } = this.data || {}
      let { isexplain, explain = [] } = fieldconfig
      let newExplain = explain.filter(o => o !== '')
      isexplain = isexplain && newExplain.length
      return isexplain
    },
    explain () {
      let newExplain = []
      const { fieldconfig = {}, fieldkey, options = [] } = this.data || {}
      if (fieldkey === 'info_level') {
        const { explain = [], type } = fieldconfig
        let arr = []
        if (type === 1) {
          arr = ['A', 'B', 'C', 'D', 'E', 'F', 'G']
        } else if (type === 2) {
          arr = this.$t('message["1444"]').split(',')
        }
        explain.forEach((item, index) => {
          let obj = {}
          arr.forEach((code, i) => {
            if (index === i) {
              obj.key = code
              obj.name = item
              newExplain.push(obj)
            }
          })
        })
      } else if (fieldkey === 'info_type') {
        options.forEach((item, index) => {
          if (item.typeshow) {
            newExplain.push({
              key: item.name,
              name: item.typeshow
            })
          }
        })
      }
      return newExplain || []
    },
    auditStatus () {
      const { audit_status: auditStatus } = this.memberInfo || {}
      return auditStatus
    },
    options () {
      const { options = [], fieldtype = '', parentid } = this.data || {}

      let isRadio = fieldtype === 'radio' || fieldtype === 'radioinfo_type'
      let isSelect = fieldtype === 'select'
      // 父级不是成交，丢单，失效
      let isChildModule = parentid === 5092 || parentid === 136528 || parentid === 136525
      // 信息类型和父级不是成交，丢单，失效，模块内的单选和下拉
      if ((isRadio || isSelect) && !isChildModule) {
        // 录入或审核
        if (this.$route.name === 'InqueryCreate' || this.$route.name === 'ClueCreate' || this.$route.name === 'ClueDetail' || this.auditStatus === 0 || this.auditStatus === -1) {
          for (let len = options.length, i = len - 1; i >= 0; i--) {
            if (options[i].visibletype === 2) {
              options.splice(i, 1)
            }
          }
        } else if (this.auditStatus === 1) { // 通过审核的详情
          for (let len = options.length, i = len - 1; i >= 0; i--) {
            if (options[i].visibletype === 1) {
              options.splice(i, 1)
            }
          }
        }
      }
      return options
    },
    infoSign () {
      const { fieldconfig = {} } = this.data || {}
      const { info_sign: infoSign } = fieldconfig
      return infoSign
    },
    infoSignOptions () {
      let { options = [] } = this.infoSign || {}
      return options
    },
    isInfoSign: {
      get () {
        let data = {}
        if (this.$route.name === 'InqueryCreate') {
          data = this.defaultMemberInfo
        } else {
          data = this.passdetailMemberInfo
        }
        const { isInfoSign } = data || {}
        return isInfoSign
      },
      set (val) {
        this.SET_IS_INFO_SIGN(val)
      }
    }
  },
  watch: {
    systemRole: {
      handler (val) {
        this.init(val)
      },
      immediate: true
    },
    value (val) {
      this.fieldvalue = this.value
    },
    data: {
      handler (val) {
        if (this.value) {
          this.fieldvalue = this.value
        } else {
          this.fieldvalue = val.fieldvalue
        }
      },
      deep: true,
      immediate: true
    }
  },

  created () {
    const { fieldtype, fieldconfig = {} } = this.data || {}
    if (fieldtype === 'radioinfo_level' && fieldconfig.type === 2) {
      this.LevelOption()
    }
  },

  methods: {
    ...mapMutations('inquery/detailData', ['updataIsBeiAn']),
    ...mapMutations('inquery/relateData', ['SET_IS_INFO_SIGN']),

    init (val) {
      const { fieldtype } = this.data || {}
      if (!val || fieldtype !== 'radioinfo_type') return

      if (this.$route.name === 'InqueryCreate' && this.baseinfo.system_role === 5) {
        // 设置-页面内默认选择的值
        if (this.isInfoSign) {
          if (this.infoSign) {
            // 默认选中信息类型标记备案
            this.isBeian = 1
          }
          let item = this.options.find(o => o.name === this.$t('message[1762]')) // 有效
          this.fieldvalue = item && item.id
        } else {
          // 默认选中信息类型的备案字段
          let item = this.options.find(o => o.name === this.$t('message[26]')) // 备案
          this.fieldvalue = item && item.id
          this.isBeian = 1
        }
        // 处理共享和store内备案的值
        this.setBeiAn(this.isBeian === 1)
        this.$bus.$emit('handleChangeBeian', this.isBeian === 1)

        this.$emit('change', this.fieldvalue)
      } else {
        // 录入/审核/详情页面，设置备案的默认值
        this.setDefaultBeian()
      }
    },
    setDefaultBeian () {
      if (this.isInfoSign) { // 如果设置了允许备案为true
        const { fieldvalue } = this.infoSign || {}
        // console.log(fieldvalue)
        this.isBeian = fieldvalue === 1 ? 1 : 0
        this.setBeiAn(this.isBeian === 1)
      } else { // 如果信息类型选择了备案
        let item = this.options.find(o => o.name === this.$t('message[26]')) // 备案
        let { id } = item || {}
        const { fieldvalue } = this.data || {}
        if (id === fieldvalue) {
          this.setBeiAn(true)
        }
      }
    },
    onChangeVal (e) {
      let { fieldkey } = this.data || {}
      this.fieldvalue = e.target.value

      // 如果没有类型标记字段，信息类型的值，修改为备案时
      if (fieldkey === 'info_type' && !this.isInfoSign) {
        let item = this.options.find(o => o.name === this.$t('message[26]')) // 备案
        let { id } = item || {}
        // 切换选择的是备案
        this.setBeiAn(id === this.fieldvalue)
        // 接口获取跟进人员默认值
        this.$bus.$emit('handleChangeBeian', this.fieldvalue)
      }
      this.$emit('change', this.fieldvalue)

      this.myForm.setFieldsValue({
        [fieldkey]: this.fieldvalue
      })
    },
    // 如果信息类型标记字段，备案切换时
    onChangeBeian (e) {
      let val = e.target.checked
      // 传递给接口的isBeian值为0或1
      this.isBeian = val ? 1 : 0
      this.data.fieldconfig.info_sign.fieldvalue = this.isBeian
      // 标记为备案，信息类型默认选中有效，之前选择过的值覆盖为有效
      // 取消备案时不处理，保留之前选择的值
      // 通过的详情，选择备案，不强制选择有效
      if (val && this.$route.name !== 'InqueryPassDetail') {
        let item = this.options.find(o => o.name === this.$t('message[1762]'))
        this.fieldvalue = item.id
        let { fieldkey } = this.data || {}
        this.myForm.setFieldsValue({
          [fieldkey]: this.fieldvalue
        })
      }
      this.$emit('change', this.fieldvalue)

      // 处理共享和store内备案的值
      this.setBeiAn(val)

      // 接口获取跟进人员默认值
      this.$bus.$emit('handleChangeBeian', val)
    },
    setBeiAn (val) {
      // 更新共享选项
      this.$bus.$emit('updateFollowShare', val)
      // 是否选择备案，在store中存储isBeian的状态，Boolean
      this.updataIsBeiAn(val)
    },
    LevelOption (val) {
      this.data.options.forEach((item, index) => {
        ['A', 'B', 'C', 'D', 'E', 'F', 'G'].forEach((code, i) => {
          if (index === i) {
            item.name = code
          }
        })
      })
    },
    checkValue (rule, value, callback) {
      const { isneeded } = this.data || {}
      if (!isneeded) {
        callback()
      } else {
        let filter = this.options.filter(item => item.id === value)
        if (filter.length) {
          callback()
        } else {
          callback(new Error(`${this.$t('message["855"]')}${this.data.fieldname}`))
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ant-form-item ::v-deep{
  .ant-form-item-children {
    display: inline-block;
  }
}
.right {
  .top {
    line-height: 32px;
    .ant-checkbox-wrapper {
      margin-right: 0;
    }
    .text {
      font-size: 12px;
      padding: 0;
    }
  }
}
.con {
  position: relative;
  padding-right: 30px;
}
.explain-btn {
  position: absolute;
  top: 0;
  // right: -30px;
  margin-left: 12px;
  cursor: pointer;
}
.ant-radio-button-wrapper {
  margin-bottom: 10px;
}
.not-edit-item ::v-deep {
  margin-bottom: 0;
  .ant-form-item-label {
    display: none;
  }
  .ant-form-item-control-wrapper{
    padding-left: 0;
  }
}
</style>
<style lang="scss">
.radio-tooltip {
  min-width: 200px;
  max-width: 400px;
  .ant-tooltip-inner {
    color: $gray3;
    min-width: 200px;
    max-width: 400px;
  }
  .ant-tooltip-content:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    left: 1px;
    top: 50%;
    margin-top: -7px;
    border-width: 7px 8px 7px 0;
    border-color: transparent;
    border-right-color: #ebebeb;
    border-style: solid;
  }
  &.ant-tooltip-placement-right {
    .ant-tooltip-arrow {
      left: 4px !important;
      z-index: 2;
      border-right-color: #fff !important;
    }
  }
  &.ant-tooltip-placement-left {
    .ant-tooltip-content:after {
      right: 1px;
      left: auto;
      margin-top: -7px;
      border-width: 7px 0 7px 8px;
      border-left-color: #ebebeb;
    }
    .ant-tooltip-arrow {
      right: 4px !important;
      z-index: 2;
      border-left-color: #fff !important;
    }
  }
}
</style>
